export const EVENT_START_TIME = new Date(Date.UTC(2026, 3, 4, 14, 0, 0)) // Saturday April 4, 2026 10am ET
export const EVENT_NAME = "SneakerCon Scavenger Hunt"
export const EVENT_DESCRIPTION = "Explore SneakerCon Philadelphia, complete quests, collect points, and win prizes!"

// feature flags
export const ENABLE_SHOP = false
export const COLLECT_WALLETS = false
export const ENABLE_FRIEND_CONNECTIONS = true
export const ENABLE_PRIZE_PROGRESSION = false

export const FRIEND_CONNECTION_POINT_REWARD = 1
export const CONNECTION_TERMS = {
    connection: "collector",
    pendingConnection: "collector request",
	connectAction: {
		currentTense: "connect",
		pastTense: "connected"
	},
	connectedAt: "You connected",
	badge: {
		name: "playing card",
		findPrompt: "Look for someone with a playing card",
		tapPrompt: "Hold your phone near their playing card to connect",
	},
}

export const POINTS_NAME: "tickets" | "points" = "points"

export const APP_BACKGROUND_IMAGE = "/images/sneakercon-philly-bg.jpg"
export const APP_LOGO_IMAGE = "/images/logo.png"

export const THRESHOLD_100_PROGRESS_IMAGE = "/images/100-percent-progress.jpg"
export const THRESHOLD_NO_PROGRESS_IMAGE = undefined
export const THRESHOLD_PRIZE_PICKUP_LOCATION = "badbad booth"

export const CHANNELS = [
  { name: "instagram", label: "Instagram" },
	{ name: "twitter", label: "Twitter" },
	{ name: "telegram", label: "Telegram" },
] as const

export function getSocialChannelUrl(
	handle: string,
	channelName: string,
): string {
	switch (channelName) {
		case "twitter":
			return `https://twitter.com/${handle}`
		case "telegram":
			return `https://t.me/${handle}`
		case "instagram":
			return `https://instagram.com/${handle}`
		default:
			console.warn(`missing social channel url config for: ${channelName}`)
			return ""
	}
}


export const ADMIN_EMAIL_DOMAINS = [
	"goonzworld.com",
	"10amstudios.xyz",
  "theprinthub.co"
]
